import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { format, parse } from 'date-fns';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Based on
 * https://gist.github.com/JoniJnm/412325c073805437c68430b11407e11b
 * but extending the NativeDateAdapter remaining implementation
 */

/**
 * https://date-fns.org/docs/parse
 * https://date-fns.org/docs/format
 */
export const MAT_DATE_FNS_DATE_FORMATS = {
  parse: {
    dateInput: 'yyyy-MM-dd', // 2020-08-24
  },
  display: {
    dateInput: 'yyyy-MM-dd', // 2020-08-24
    monthYearLabel: 'LLL y', // Aug 2020
    dateA11yLabel: 'MMMM d, y', // August 24, 2020
    monthYearA11yLabel: 'MMMM y', // August 2020
  },
};

@Injectable()
export class DateFnsDateAdapter extends NativeDateAdapter {
  override parse(value: any, parseFormat?: any): Date | null {
    if (!value) {
      return null;
    }
    if (typeof value === 'number') {
      return new Date(value);
    }
    // try parse based on expected format
    const parsedStrict = parse(value, parseFormat, new Date());
    if (this.isValid(parsedStrict)) {
      return parsedStrict;
    }
    // fall back to loose Date.parse
    return new Date(Date.parse(value));
  }

  override format(date: Date, displayFormat: any): string {
    return format(date, displayFormat);
  }
}
